// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".funnel-settings-header[data-v-0aab9b5e] {\n  display: flex;\n  flex-direction: row-reverse;\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
